export const ColumnsFilterPagesEnum = {
  contacts: {
    key: "contacts",
  },
  properties: {
    key: "properties",
  },
  unitsSales: {
    key: "unitsSales",
  },
  unitsLease: {
    key: "unitsLease",
  },
  leadsSales: {
    key: "leadsSales",
  },
  leadsLease: {
    key: "leadsLease",
  },
  mortgageLeads: {
    key: "mortgageLeads",
  },
  activitySalesRelated: {
    key: "activitySalesRelated",
  },
  activitySalesAll: {
    key: "activitySalesAll",
  },
  activityLeaseRelated: {
    key: "activityLeaseRelated",
  },
  activityLeaseAll: {
    key: "activityLeaseAll",
  },
  activityManagmentRelated: {
    key: "activityManagmentRelated",
  },
  activityManagmentAll: {
    key: "activityManagmentAll",
  },
  activityCallCenterRelated: {
    key: "activityCallCenterRelated",
  },
  activityCallCenterAll: {
    key: "activityCallCenterAll",
  },
  assignAgent: {
    key: "assignAgent",
  },
  rotationTable: {
    key: "rotationTable",
  },
  activityType: {
    key: "activityType",
  },
  2: {
    key: "ActiveReport",
  },
  3: {
    key: "LeadsReport",
  },
  4: {
    key: "ClosedLeadsReport",
  },
  5: {
    key: "DailyLeadReport",
  },
  6: {
    key: "ActivitiesvsLeadsReport",
  },
  7: {
    key: "BulkOwnersReport",
  },
  8: {
    key: "BuyerLeadReportWithLastActivity",
  },
  9: {
    key: "ContactswithoutLeadReport",
  },
  10: {
    key: "OpenLeadsAgentWiseReport",
  },
  11: {
    key: "TransactionContactsInformationReport",
  },
  12: {
    key: "ContactEnteredWithMediaType",
  },
  13: {
    key: "ViewingReport_LeasingAgents",
  },
  14: {
    key: "LeadActivityReport",
  },
  15: {
    key: "ContactsReportWithEmailAddress",
  },
  16: {
    key: "ContactReport",
  },
  17: {
    key: "developers",
  },
  Vendors: {
    key: "vendors",
  },
  ClientsTracking: {
    key: "clientsTracking",
  },
};
